import { Footer } from "antd/es/layout/layout";

const CopyRight = () => {
  return (
    <Footer
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#888",
        marginTop: "20px",
        marginBottom: "10px",
        fontWeight: "bold",
        position: "relative",
        bottom: 0,
        width: "100%",
      }}
    >
      Copyright &copy; {new Date().getFullYear()}, Powered by Almega Insights.
    </Footer>
  );
};

export default CopyRight;
